<div class="d-flex align-items-center justify-content-between mb-2">
  <div class="d-flex flex-column" style="gap: 0.5em; width: 100%">
    <div class="d-flex icon-item align-items-center justify-content-between" style="position: relative">
      <img [src]="getCategoryIcon()" width="25" alt="" />
    </div>

    <div class="d-flex flex-column align-items-start mb-3">
      <span style="text-transform: none; font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1;">
        {{ getCategoryType() }}
      </span>

      <!-- Category Title -->
      <h3 style="font-size: 22px; font-weight: 500; font-family: 'Rubik'; text-transform: none; margin-bottom: 5px;">
        {{ item?.title }}

        <span
          style="
            font-size: 14px;
            text-transform: none;
            font-weight: 400;
            color: #737373;
            font-family: 'Rubik';
          "
          *ngIf="item.categoryName == 'RENT-A-CAR'"
        >
          o similar
        </span>
      </h3>

      <!-- Stars --->
      <!-- *note: just for hotel category --->
      <div *ngIf="item.categoryId === 1" class="d-flex justify-content-start pb-1 mb-2">
        <ng-container *ngFor="let star of starArray">
          <img
            *ngIf="star <= rate"
            class="mr-1"
            width="12"
            height="12"
            src="../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />

          <img
            class="mr-1"
            *ngIf="star > rate"
            width="12"
            height="12"
            style="filter: grayscale(1); opacity: 0.5"
            src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />
        </ng-container>
      </div>

      <!-- Hotel Location -->
      <div *ngIf="item.categoryId === 1" class="d-flex flex-column mb-2" style="gap: 5px">
        <button (click)="onOpenMap()" class="btn view-map-button d-flex align-items-center p-0" style="gap: 4px; outline: none; box-shadow: none;">
          <svg style="width: 15px;" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398.49 517.42"><path d="M199.25,308.32A109.08,109.08,0,1,1,308.32,199.25,109.2,109.2,0,0,1,199.25,308.32Zm0-180.33a71.26,71.26,0,1,0,71.26,71.26A71.33,71.33,0,0,0,199.25,128Z"/><path d="M186.8,506.53C179.17,499.85,0,341.48,0,199.25,0,89.38,89.38,0,199.25,0S398.49,89.38,398.49,199.25c0,142.21-179.17,300.6-186.79,307.27l-12.45,10.9ZM199.25,37.82c-89,0-161.43,72.41-161.43,161.43,0,50.82,29.6,114.76,85.6,184.89a844.93,844.93,0,0,0,73.87,80.56l2,1.88,2-1.88a848.9,848.9,0,0,0,73.87-80.56c56-70.13,85.59-134.07,85.59-184.89C360.67,110.23,288.26,37.82,199.25,37.82Z"/></svg>

          <span
            style="
              font-size: 12px;
              font-weight: 600;
              font-family: 'Rubik';
              line-height: 1;
              text-transform: none;
            "
          >Ver mapa</span>
        </button>

        <p
          class="m-0"
          style="
            font-size: 12px;
            font-weight: 400;
            line-height: 1;
            font-family: 'Rubik';
            color: #747474;
            text-transform: none;
          "
        >
          {{item?.location}}
        </p>
      </div>

      <!-- Refundable -->
      <div *ngIf="item.categoryId !== 8">
        <span *ngIf="item.rateClassId === 'R' || item.rateClass === 'R' || item?.pricing?.rateClass === 'R'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #34c26d; background-color: #defef4; text-transform: none; border-radius: 6px;">Reembolsable</span>
        <span *ngIf="item.rateClassId === 'NR' || item.rateClass === 'NR' || item?.pricing?.rateClass === 'NR'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #ed3b5b; background-color: #fde6ea; text-transform: none; border-radius: 6px;">No Reembolsable</span>
      </div>
    </div>
  </div>
</div>

<!-- Projected child-specific content -->
<div class="d-flex flex-column">
  <!-- Toggle Button -->
  <button
    class="toggle-btn"
    (click)="toggleExpanded()"
    type="button"
  >
    <span class="toggle-label" *ngIf="item.categoryId === 1">
      {{ isExpanded ? 'Ocultar habitaciones' : 'Ver habitaciones' }}
    </span>

    <span class="toggle-label" *ngIf="item.categoryId === 8 && item.transfers">
      {{ isExpanded ? 'Ocultar traslados' : 'Ver traslados' }}
    </span>

    <span class="toggle-label" *ngIf="item.ticketItems">
      {{ isExpanded ? 'Ocultar tickets' : 'Ver tickets' }}
    </span>

    <span class="toggle-label" *ngIf="(item.categoryId !== 1) && (item.categoryId !== 8 || !item.transfers) && !item.ticketItems">
      {{ isExpanded ? 'Ver menos' : 'Ver detalle' }}
    </span>

    <span class="toggle-arrow" [class.rotated]="!isExpanded">
      <img  src="../../../../../../assets/img/app/little-icons/up-arrow-angle.svg"/>
    </span>
  </button>

  <!-- Collapsible Content -->
  <div class="collapsible-content" [class.expanded]="isExpanded">
    <ng-content></ng-content>
  </div>
</div>

<div class="d-flex flex-column align-content-start mr-3">
  <div class="title-cityName text-uppercase" style="width: 100%">
    <div style="text-align: start">
      <div
        class="mr-3 py-3"
        [ngStyle]="{
          'border-top': '1.5px solid ' + styleSidebar?.background_color,
          'border-bottom': !isCancelled() ? '1.5px solid ' + styleSidebar?.background_color : 'none'
        }"
      >
        <p
          class="m-0"
          style="
            font-family: 'Muli', sans-serif;
            font-size: 14px;
            font-weight: 400;
            line-height: 1;
            text-transform: none;
          "
        >
          Tarifa Total
        </p>
        <div class="d-flex justify-content-start align-items-center" style="gap: 1px;">
          <p
            class="m-0"
            style="
              font-family: 'Muli', sans-serif;
              font-size: 18px;
              font-weight: 600;
              line-height: 1.2
            ">
            {{ currencyAgency?.code }}
            <span *ngIf="!isCancelled()">{{ displayPrice | number: "1.2-2" }}</span>
            <span *ngIf="isCancelled()">{{ 0 | number: "1.2-2" }}</span>
          </p>
          <usb-tooltip-convert-amount
            *ngIf="!isCancelled()"
            [clientsSettingAppBooking]="clientsSettingAppBooking"
            [currencyProduct]="currencyAgency?.code"
            [valueProduct]="displayPrice">
          </usb-tooltip-convert-amount>
        </div>

        <div
          *ngIf="hasOriginalPriceDiff() && !isCancelled()"
          class="d-flex justify-content-start flex-column"
        >
          <!-- Traslados: una línea por moneda (soporta ida/vuelta en monedas distintas) -->
          <ng-container *ngIf="getOriginalCurrencyBreakdown().length > 0; else singleCurrency">
            <ng-container *ngFor="let line of getOriginalCurrencyBreakdown()">
              <p
                class="mb-0"
                style="font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 600; line-height: 1.2;"
                *ngIf="line.currency"
              >
                {{ line.currency }} {{ line.total | number: "1.2-2" }}
              </p>
            </ng-container>
          </ng-container>

          <ng-template #singleCurrency>
            <p
              class="mb-0"
              style="font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 600; line-height: 1.2;"
              *ngIf="item?.currency"
            >
              {{ item?.currency }} {{ getOriginalCurrencyPrice() | number: "1.2-2" }}
            </p>
          </ng-template>

          <span
            *ngIf="item?.currency"
            style="font-family: 'Muli', sans-serif; font-size: 11px; font-weight: 400; line-height: 1.2; text-transform: none;"
          >
            impuestos incluidos
          </span>
        </div>
      </div>

      <div *ngIf="!isCancelled()" class="d-flex align-items-end pt-3" style="gap: 10px;">
        <img width="30" height="30" src="../../../../../../assets/icons/search-result/BLICKOIS-01.svg" />

        <div class="d-flex flex-column">
          <span
            style="
              font-size: 13px;
              font-family: 'Rubik';
              font-weight: 400;
              line-height: 1;
              text-transform: none;
              display: inline-block;
              margin-bottom: 2px;
            "
          >
            Blickoins acumulados
          </span>

          <span
            style="
              color: #ffc039;
              font-size: 14px;
              font-weight: 600;
              line-height: 1;
              font-family: 'Muli', sans-serif;
            "
          >{{ item?.blickoins | number: '1.2-2' }} BKS - {{ item?.creditBlickoins | number: '1.2-2' }} USD</span>
        </div>
      </div>
    </div>
  </div>
</div>
